import React, { useState } from "react"
import { Form, Modal, ModalBody, ModalHeader, Table } from "reactstrap"
import axios from "axios"
import { useHistory } from "react-router-dom"

const ViewHistory = ({
  viewHistoryToggle,
  selectedItem,
  editing,
  setEditing,
  setAuth,
}) => {
  // console.log("selectedItem", selectedItem)
  const history = useHistory()

  //************* form control ******/
  const [modal, setmodal] = useState(true)
  const toggle = () => {
    viewHistoryToggle()
  }
  const onClose = () => {
    viewHistoryToggle()
  }

  // *********************** Submit handler ******************************** //
  const submitHandler = e => {
    e.preventDefault()

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      Action: "1",
      PStageID: selectedItem.PStageID,
    }
    // console.log("formData", formData)

    axios
      .post(
        process.env.REACT_APP_API_URL + "api/inspection/InspectionAction.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log(res)
        setEditing(!editing)
      })
      .catch(err => console.log(err))

    onClose()
  }

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-md">
      <ModalHeader>
        Inspection Report History
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody className="px-4 py-3 text-center">
        <Table bordered className="text-center mb-5">
          <thead>
            <tr>
              <th>#</th>
              <th>Approved By</th>
              <th>Approved At</th>
            </tr>
          </thead>

          {selectedItem.ApprovedData && (
            <tbody>
              <tr>
                <th>{1}</th>
                <td>{selectedItem.Approvedby}</td>
                <td>{selectedItem.ApprovedData}</td>
              </tr>
            </tbody>
          )}
        </Table>
      </ModalBody>
    </Modal>
  )
}

export default ViewHistory
